import React, { cloneElement } from "react";
import { TrendingUp, Zap, Shield, BarChart } from "lucide-react";
export const WhyGigi = () => {
  return <div className="py-20 bg-gray-50" data-id="element-1504">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1505">
        <div className="text-center mb-16" data-id="element-1506">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1507">
            We've Done This Sh*t Before
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1508">
            After 15 years of figuring out what actually works in B2B sales (and
            watching countless campaigns fail), we built an AI that doesn't make
            rookie mistakes.
          </p>
        </div>
        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-16" data-id="element-1509">
          <Stat number="15+" label="Years in the Game" description="Yeah, we've seen some stuff" data-id="element-1510" />
          <Stat number="40+" label="Companies Scaled" description="From garage startups to big shots" data-id="element-1511" />
          <Stat number="70%" label="Less Busywork" description="Do less, achieve more" data-id="element-1512" />
          <Stat number="2M+" label="Messages Analyzed" description="So you don't have to learn the hard way" data-id="element-1513" />
        </div>
        {/* Key Benefits */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1514">
          <Benefit icon={<TrendingUp className="text-[#6366f1]" data-id="element-1516" />} title="Data > Opinion" description="We've seen what works and what bombs. Our AI uses actual data, not just 'best practices' someone made up." data-id="element-1515" />
          <Benefit icon={<Zap className="text-[#6366f1]" data-id="element-1518" />} title="Battle-Tested Templates" description="Templates that generated millions in real deals. Not theoretical BS from LinkedIn gurus." data-id="element-1517" />
          <Benefit icon={<Shield className="text-[#6366f1]" data-id="element-1520" />} title="You're Still the Boss" description="AI does the heavy lifting, but you get final say. No random messages going out without your OK." data-id="element-1519" />
          <Benefit icon={<BarChart className="text-[#6366f1]" data-id="element-1522" />} title="Gets Better Every Day" description="Like a good wine, but for your outreach. Every campaign makes the system smarter." data-id="element-1521" />
        </div>
      </div>
    </div>;
};
const Stat = ({
  number,
  label,
  description
}) => <div className="text-center p-6 bg-white rounded-lg shadow-lg border border-gray-100" data-id="element-1523">
    <div className="text-4xl font-bold text-[#6366f1] mb-2" data-id="element-1524">{number}</div>
    <div className="font-semibold text-gray-900 mb-1" data-id="element-1525">{label}</div>
    <div className="text-sm text-gray-600" data-id="element-1526">{description}</div>
  </div>;
const Benefit = ({
  icon,
  title,
  description
}) => <div className="flex gap-4 p-6 bg-white rounded-lg shadow-lg border border-gray-100" data-id="element-1527">
    <div className="flex-shrink-0" data-id="element-1528">
      <div className="w-12 h-12 bg-[#d5ff00]/20 rounded-lg flex items-center justify-center" data-id="element-1529">
        {cloneElement(icon, {
        size: 24,
        strokeWidth: 2
      })}
      </div>
    </div>
    <div data-id="element-1530">
      <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1531">{title}</h3>
      <p className="text-gray-600" data-id="element-1532">{description}</p>
    </div>
  </div>;